import { CustomerType } from '@repo/common';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@repo/shadcn';
import { useMemo } from 'react';

import { ResetFilterButton } from '@/components/ui/button';
import TextSearchFilter from '@/components/ui/search-filter/search-filter';
import { useUrlFilter } from '@/hooks';

export const CustomerListFilters = () => {
    const { getSearchFilter, setSearchFilter } = useUrlFilter();

    const customerType = getSearchFilter('customer_type') || '';

    const customerTypeOptions = useMemo(
        () => [
            { label: CustomerType.WHOLESALE, value: CustomerType.WHOLESALE },
            { label: CustomerType.RETAIL, value: CustomerType.RETAIL },
        ],
        [],
    );

    return (
        <div className="mb-5 grid w-full grid-cols-1 gap-3 sm:grid-cols-2 lg:flex lg:items-center">
            <div className="relative min-w-0 sm:col-span-2 lg:w-[300px] [&_input]:!w-full">
                <TextSearchFilter
                    onChangeSearch={(e) => {
                        setSearchFilter('search', e.target.value);
                    }}
                    placeholder="Customer Name"
                />
            </div>
            <div className="w-full lg:w-auto">
                <Select
                    defaultValue={customerType}
                    onValueChange={setSearchFilter.bind(null, 'customer_type')}
                    value={customerType}
                >
                    <SelectTrigger className="w-full capitalize lg:w-[180px]">
                        <SelectValue placeholder="Select type" />
                    </SelectTrigger>
                    <SelectContent>
                        {customerTypeOptions.map(({ label, value }) => (
                            <SelectItem key={value} value={value}>
                                {label}
                            </SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            </div>
            <div className="w-full lg:w-auto [&_button]:w-full lg:[&_button]:w-auto">
                <ResetFilterButton />
            </div>
        </div>
    );
};

CustomerListFilters.displayName = 'CustomerFilter';
